import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./web.css";

const Navbar = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  const handleShowNavbar = () => {
    setShowNavbar(!showNavbar);
  };

  return (
    <>
      <nav className="navbar">
        <div className="container">
          <div className="logo">
            <a href="/" className="logo">
              <img  src="/assets/img/logo1.png" alt="navbar brand"/>
            </a>
          </div>

          <div className="menu-icon" onClick={handleShowNavbar}>
            <Hamburger />
          </div>

          <div className={`nav-elements ${showNavbar ? "active" : ""}`}>
            <ul>
              <li>
                <NavLink
                  to="/"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Home
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/property"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Property
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/about"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  About
                </NavLink>
              </li>
              <li>
                <NavLink
                  to="/contact"
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  Contact
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

// ✅ Hamburger Icon
const Hamburger = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="52" height="24" viewBox="0 0 52 24">
    <g transform="translate(-294 -47)">
      <rect width="42" height="4" rx="2" transform="translate(304 47)" fill="#ffffff" />
      <rect width="42" height="4" rx="2" transform="translate(304 67)" fill="#ffffff" />
      <rect width="52" height="4" rx="2" transform="translate(294 57)" fill="#ffffff" />
    </g>
  </svg>
);

// ✅ Logo
const Logo = () => (
  <svg
    id="logo-52"
    width="120"
    height="30"
    viewBox="0 0 170 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M51.2775 29.3232H63.2295V25.7232H55.5255V12.1632H51.2775V29.3232Z"
      fill="#2F234F"
    />
  </svg>
);

export default Navbar;
